import { http, HttpResponse } from 'msw'

export const mockCreateCustomer = http.post(
  '/my-business/api/agency/v1/customers',
  () => {
    return HttpResponse.json(
      {
        timestamp: new Date().toISOString(),
      },
      { status: 201 },
    )
  },
)
